import React from 'react';

import Framework from "@beardeddevops/react.framework";
import {Collections} from "components";
import Tab from "@material-ui/core/Tab";
import Tabs from "@material-ui/core/Tabs";

const breadcrumbsStatic = [
	{
		name: 'Dashboard',
		url: '/',
		icon: 'dashboard',
	},
	{
		name: 'Acquisitions',
		url: '/acquisitions',
		icon: 'download',
	},
	{
		name: 'In-Network Transfers',
		url: '/acquisitions/pendings',
		icon: 'hourglass',
	}
];

export default class Pendings extends Framework.Components.View {
	constructor(props) {
		super(props, "pending");
	}

	render() {
		return (
			<div className="container-fluid">

				<Framework.Components.PageBar breadcrumbs={breadcrumbsStatic} history={this.props.history}/>
				<Tabs value={this.state.tab} onChange={this.handleTabChange} component="div">
				<Tab label="Pending" value="pending"/>
				<Tab label="Processing" value="processing"/>
			</Tabs>

				<div style={{display: this.state.tab === 'pending' ? 'block' : 'none'}}>
					<Collections.AcquisitionPendings
					history={this.props.history}
					locations={this.props.locations}
					states={this.props.states}
					reloadShell={this.props.reloadShell}
					reloadPage={this.refreshPage}
					reloadSelf={this.state.refresh}
				/>
				</div>

				{this.state.tab === 'processing' && <Collections.DavidsonsPendingsStaging
					history={this.props.history}
					locations={this.props.locations}
					states={this.props.states}
					reloadShell={this.props.reloadShell}
					reloadPage={this.refreshPage}
					reloadSelf={this.state.refresh}
				/>}


			</div>
		);
	}
}
